import React from "react";

const Arrow = ({ width = 300, height = 50, color = "black" }) => {
  const shaftWidth = width * 0.8; // 80% of the total width is the shaft
  const centerY = height / 2; // Vertical center

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Arrow shaft */}
      <rect
        x="0"
        y={height * 0.4}
        width={shaftWidth}
        height={height * 0.2}
        fill={color}
      />
      {/* Arrowhead */}
      <polygon
        points={`${shaftWidth},0 ${width},${centerY} ${shaftWidth},${height}`}
        fill={color}
      />
    </svg>
  );
};

export default Arrow;
